import { PassengerRoomCountItemsType, PassengersCountType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/types";
import { numberConvert } from "@website/utils/number-convert";
import cloneDeep from "lodash-es/cloneDeep";
import { useEffect, useState } from "react";

//TODO: where put these ??
const toFarsi = (value: number) => numberConvert(value, {
  locale: "fa"
});
const number_of_adult = "تعداد بزرگسال";
const greater_than_n_years = (age: number) => `${toFarsi(age)} سال به بالا`;
const number_of_child = "تعداد کودک";
const to_n_years = (age: number) => `تا ${toFarsi(age)} سال`;
const between_m_and_n_years = (age_one: number, age_two: number) => `${toFarsi(age_one)} تا ${toFarsi(age_two)} سال`;
const number_of_passenger_and_room = "تعداد مسافر و اتاق";
const x_passenger_and_y_room = ({
  passenger_count,
  room_count
}: {
  passenger_count: number;
  room_count: number;
}) => `${toFarsi(passenger_count)} مسافر، ${toFarsi(room_count)} اتاق`;
type UsePassengerRoomCountTourType = {
  initialValues: PassengersCountType;
};
export const usePassengerRoomCountTour = (properties: UsePassengerRoomCountTourType) => {
  const [temporaryPassengerCount, setTemporaryPassengerCount] = useState<PassengersCountType>(properties.initialValues || [{
    adult: [1, 1],
    child: []
  }]);
  const [passengerCount, setPassengerCount] = useState<PassengersCountType>(properties.initialValues || [{
    adult: [1, 1],
    child: []
  }]);
  const totalPassenger = passengerCount.reduce((accumulator, current) => accumulator + current?.adult?.length + current?.child?.length, 0);
  const onChange = (value: number, listIndex: number, childIndex: number) => {
    if (value > -1) {
      setPassengerCount(previous => {
        const copyState = cloneDeep(previous);
        if (childIndex === 0) {
          copyState[listIndex].adult = Array.from({
            length: value
          }).fill(1) as Array<number>;
        } else if (value > copyState[listIndex].child.length) {
          copyState[listIndex].child[value - 1] = undefined;
        } else if (value > -1) copyState[listIndex].child = copyState[listIndex].child.splice(0, value);
        return copyState;
      });
    }
  };
  const defaultRooms = (() => {
    if (properties.initialValues) {
      return properties.initialValues.map((item, index) => createRoom((index + 1).toString(), item.adult, item.child, onChange));
    }
    return [{
      id: "1",
      title: "اتاق",
      children: [{
        increaseDisabled: false,
        decreaseDisabled: false,
        title: number_of_adult,
        subtitle: greater_than_n_years(12),
        value: [1],
        onChange
      }, {
        increaseDisabled: false,
        decreaseDisabled: false,
        title: number_of_child,
        subtitle: to_n_years(12),
        value: [],
        error: [],
        onChange
      }]
    }];
  })();
  const [updatedList, setUpdatedList] = useState<Array<PassengerRoomCountItemsType>>(defaultRooms);
  const [, setTemporaryUpdatedList] = useState<Array<PassengerRoomCountItemsType>>([{
    id: "1",
    title: "اتاق",
    children: [{
      increaseDisabled: false,
      decreaseDisabled: false,
      title: number_of_adult,
      subtitle: greater_than_n_years(12),
      value: [1],
      onChange
    }, {
      increaseDisabled: false,
      decreaseDisabled: false,
      title: number_of_child,
      subtitle: to_n_years(12),
      value: [],
      error: [],
      onChange
    }]
  }]);
  const validation = () => {
    const clear = [];
    setUpdatedList(previous_0 => {
      let copyPrevious = [...previous_0];
      copyPrevious = copyPrevious.map(items => {
        for (const item_0 of items.children) {
          if (item_0.value) {
            for (const [index_0, value_0] of item_0.value.entries()) {
              if (value_0 === undefined || value_0 === null) {
                clear.push(1);
                if (item_0.error) {
                  item_0.error[index_0] = 1;
                }
              }
            }
          }
        }
        return items;
      });
      return copyPrevious;
    });
    return clear.length === 0;
  };
  const onTemporaryListUpdate = () => {
    const total = passengerCount?.reduce((accumulator_0, current_0) => accumulator_0 + current_0?.adult?.length + current_0?.child?.length, 0);
    setUpdatedList(previous_1 => {
      const copyUpdatedList = cloneDeep(previous_1);
      setTemporaryUpdatedList(copyUpdatedList.map((items_0, index_1) => {
        const ADULT = passengerCount[index_1]?.adult;
        const CHILD = passengerCount[index_1]?.child;
        return {
          ...items_0,
          children: items_0?.children?.map((item_1, index_) => ({
            ...item_1,
            decreaseDisabled: index_ === 0 ? ADULT?.length === 1 || Math.floor(CHILD?.length / ADULT?.length) === 3 || Math.floor(CHILD?.length / (ADULT?.length - 1)) > 3 : CHILD?.length === 0,
            increaseDisabled: index_ === 0 ? ADULT?.length + CHILD?.length > 5 || total > 8 : ADULT?.length + CHILD?.length > 5 || total > 8 || Math.floor(CHILD?.length / ADULT?.length) === 3,
            value: index_ === 0 ? ADULT : CHILD,
            ...(index_ === 1 ? {
              error: item_1?.error?.filter(value_1 => value_1 !== undefined).map(value_2 => value_2 ?? 0) || []
            } : null)
          }))
        };
      }));
      return previous_1;
    });
  };
  const onSubmitPassengerCount = (onClosePopover: () => void) => {
    if (validation()) {
      setPassengerCount(previous_2 => {
        setTemporaryPassengerCount(state => previous_2.map((item_2, index_2) => {
          if (state[index_2]) {
            state[index_2]["adult"] = item_2?.adult;
            state[index_2]["child"] = item_2?.child;
          } else {
            state[index_2] = {
              adult: [],
              child: []
            };
            state[index_2]["adult"] = item_2?.adult;
            state[index_2]["child"] = item_2?.child;
          }
          return state[index_2];
        }));
        return previous_2;
      });
      onTemporaryListUpdate();
      onClosePopover();
    }
  };
  useEffect(() => {
    setUpdatedList(previous_3 => previous_3.map((items_1, index_3) => {
      const ADULT_0 = passengerCount[index_3]?.adult;
      const CHILD_0 = passengerCount[index_3]?.child;
      return {
        ...items_1,
        children: items_1?.children.map((item_3, index__0) => ({
          ...item_3,
          decreaseDisabled: index__0 === 0 ? ADULT_0?.length === 1 || Math.floor(CHILD_0?.length / ADULT_0?.length) === 3 || Math.floor(CHILD_0?.length / (ADULT_0?.length - 1)) > 3 : CHILD_0?.length === 0,
          increaseDisabled: index__0 === 0 ? ADULT_0?.length + CHILD_0?.length > 5 || totalPassenger > 8 : ADULT_0?.length + CHILD_0?.length > 5 || totalPassenger > 8 || Math.floor(CHILD_0?.length / ADULT_0?.length) === 3,
          value: index__0 === 0 ? ADULT_0 : CHILD_0,
          ...(index__0 === 1 ? {
            error: item_3?.error?.filter(value_3 => value_3 !== undefined).map(value_4 => value_4 ?? 0) || []
          } : null)
        }))
      };
    }));
  }, [passengerCount, totalPassenger]);
  const onDeletePassengerCountList = (id: string) => {
    if (updatedList.length > 1) {
      setUpdatedList(previous_4 => previous_4.filter(item_4 => Number(item_4.id) !== Number(id)).map((item_5, index_4) => {
        item_5.id = `${index_4 + 1}`;
        return item_5;
      }));
    }
    setPassengerCount(previous_5 => previous_5.filter((_, index_5) => index_5 + 1 !== Number(id)));
  };
  const onAddPassengerCountList = () => {
    setUpdatedList(previous_6 => {
      const copyUpdatedList_0 = [...previous_6];
      copyUpdatedList_0.push({
        id: `${previous_6.length + 1}`,
        title: "اتاق",
        children: [{
          increaseDisabled: false,
          decreaseDisabled: false,
          title: number_of_adult,
          subtitle: greater_than_n_years(12),
          value: totalPassenger < 8 ? [1, 1] : [1],
          onChange
        }, {
          increaseDisabled: false,
          decreaseDisabled: false,
          title: number_of_child,
          subtitle: between_m_and_n_years(2, 12),
          value: [],
          error: [],
          onChange
        }]
      });
      return copyUpdatedList_0;
    });
    setPassengerCount(previous_7 => {
      const copyPassengerCount = [...previous_7];
      copyPassengerCount.push({
        adult: totalPassenger < 8 ? [1, 1] : [1],
        child: []
      });
      return copyPassengerCount;
    });
  };
  const onChangeChildAge = (value_5: string, listIndex_0: number, childIndex_0: number) => {
    setUpdatedList(previous_8 => {
      const copyPrevious_0 = [...previous_8];
      copyPrevious_0[listIndex_0].children[1].value[childIndex_0] = Number(value_5);
      copyPrevious_0[listIndex_0].children[1].error ??= [];
      copyPrevious_0[listIndex_0].children[1].error[childIndex_0] = 0;
      return copyPrevious_0;
    });
    setPassengerCount(previous_9 => {
      const copyPassengerCount_0 = [...previous_9];
      copyPassengerCount_0[listIndex_0].child[childIndex_0] = Number(value_5);
      return copyPassengerCount_0;
    });
  };
  const onClosePassengerButton = () => {
    setTemporaryPassengerCount(state_0 => {
      setPassengerCount(state_0);
      return state_0;
    });
    const total_0 = temporaryPassengerCount?.reduce((accumulator_1, current_1) => accumulator_1 + current_1?.adult?.length + current_1?.child?.length, 0);
    setTemporaryUpdatedList(previous_10 => {
      const copyTemporaryUpdatedList = cloneDeep(previous_10);
      setUpdatedList(copyTemporaryUpdatedList?.map((items_2, index_6) => {
        const ADULT_1 = temporaryPassengerCount[index_6]?.adult;
        const CHILD_1 = temporaryPassengerCount[index_6]?.child;
        return {
          ...items_2,
          children: items_2?.children.map((item_6, index__1) => ({
            ...item_6,
            decreaseDisabled: index__1 === 0 ? ADULT_1?.length === 1 || Math.floor(CHILD_1?.length / ADULT_1?.length) === 3 || Math.floor(CHILD_1?.length / (ADULT_1?.length - 1)) > 3 : CHILD_1?.length === 0,
            increaseDisabled: index__1 === 0 ? ADULT_1?.length + CHILD_1?.length > 5 || total_0 > 8 : ADULT_1?.length + CHILD_1?.length > 5 || total_0 > 8 || Math.floor(CHILD_1?.length / ADULT_1?.length) === 3,
            value: index__1 === 0 ? ADULT_1 : CHILD_1,
            ...(index__1 === 1 ? {
              error: item_6?.error?.filter(value_6 => value_6 !== undefined).map(value_7 => value_7 ?? 0) || []
            } : null)
          }))
        };
      }));
      return previous_10;
    });
  };
  return {
    passengerCountTitle: number_of_passenger_and_room,
    passengerCountResult: x_passenger_and_y_room({
      passenger_count: passengerCount?.reduce((accumulator_2, current_2) => accumulator_2 + current_2?.adult?.length + current_2?.child?.length, 0),
      room_count: passengerCount?.length
    }),
    passengerCountList: updatedList,
    passengerCount,
    onSubmitPassengerCount,
    onChange,
    onDeletePassengerCountList,
    onAddPassengerCountList,
    onChangeChildAge,
    totalPassenger,
    onClosePassengerButton
  };
};

//TODO: Where it should be?
const createRoom = (id: string, adult: Array<number>, child: Array<number | undefined>, onChange: (value: number, listIndex: number, childIndex: number) => void) => ({
  id: id,
  title: "اتاق",
  children: [{
    increaseDisabled: false,
    decreaseDisabled: false,
    title: number_of_adult,
    subtitle: greater_than_n_years(12),
    value: adult,
    onChange
  }, {
    increaseDisabled: false,
    decreaseDisabled: false,
    title: number_of_child,
    subtitle: to_n_years(12),
    value: child,
    error: [],
    onChange
  }]
});